import { useRouteError } from "react-router";

import { ErrorBox } from "@/components/Spinner";
import { ButtonLink, Page, PageHeader } from "@/components/ui";

/**
 * What the router shows when something throws while a page renders. The data router (which the app
 * runs on so that a form can hold a navigation, see ``main.tsx``) catches a rendering exception at
 * its route, where the app used to have nothing and drew a blank page; without an ``errorElement``
 * it would print its own "Unexpected Application Error!" with the stack. This is the same failure,
 * said in the console's words, with the raw error one click away and a way out that keeps the
 * session (a router link, not a reload: the sign-in lives in memory).
 */
export function RouteError() {
  const error = useRouteError();
  return (
    <div className="min-h-screen bg-ground p-6 text-ink">
      <Page width="form">
        <PageHeader
          title="Something went wrong"
          subtitle="This page could not be displayed. Going back to the home page usually clears it."
          actions={
            <ButtonLink to="/" variant="primary">
              Back to home
            </ButtonLink>
          }
        />
        <ErrorBox error={error} />
      </Page>
    </div>
  );
}
